import { render, staticRenderFns } from "./pending-space.vue?vue&type=template&id=4fe39227&scoped=true"
import script from "./pending-space.vue?vue&type=script&lang=js"
export * from "./pending-space.vue?vue&type=script&lang=js"
import style0 from "./pending-space.vue?vue&type=style&index=0&id=4fe39227&prod&scoped=true&lang=css"
import style1 from "./pending-space.vue?vue&type=style&index=1&id=4fe39227&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe39227",
  null
  
)

export default component.exports